// extracted by extract-css-chunks-webpack-plugin
module.exports = {"LogoOnlyLayout":"vx10mZSj","header":"_Eiq84cS","logoContainer":"b1Fb1Raq","backButton":"zwoEnre_","v2":"ImFc8uwJ","content":"W0PvcgUh","headerRightPart":"Lav627L6"};